import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import './styles/index.css'

console.log('Main.jsx is loading'); // Debug log

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: 10 * 60 * 1000, // 10 minutes - longer cache for better performance
      cacheTime: 15 * 60 * 1000, // 15 minutes - keep in memory longer
      refetchOnMount: false, // Don't refetch if data is fresh
      refetchInterval: false, // Disable automatic background refetching
    },
  },
})

try {
  const root = document.getElementById('root');
  console.log('Root element:', root); // Debug log
  
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  )
  console.log('React app rendered successfully'); // Debug log
} catch (error) {
  console.error('Error rendering React app:', error);
} 